// Mock data for Grupo IFT - Curso de Motorista TVDE landing page

export const brand = {
  name: "GRUPO ift",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_tvde-academy/artifacts/b9xfm6wf_logo_grupoift_cinza.png",
  email: "geral@grupoift.pt",
  location: "Viana do Castelo",
  tagline: "INOVAR. FAZER. TRANSFORMAR.",
};

export const nav = {
  cta: "Quero ser contactado",
};

export const hero = {
  badge: "Certificação MTVDE",
  titleLine1: "Curso de",
  titleLine2: "Motorista",
  titleLine3: "TVDE",
  lead: "Dá o próximo passo para trabalhar como motorista TVDE.",
  description:
    "Realiza a formação necessária para obteres ou renovares a tua certificação de motorista TVDE, com o acompanhamento do Grupo IFT.",
  tags: [
    "Formação inicial ou renovação",
    "Certificação MTVDE",
    "Acompanhamento durante o processo",
  ],
  cta: "Quero receber informações",
  image:
    "https://customer-assets-v7afamib.emergentagent.net/job_tvde-academy/artifacts/zqtf0hs8_pexels-tim-samuel-5835467.webp",
  imageAlt: "Motorista TVDE profissional ao volante",
  stat: { value: "50h", label: "Formação Inicial" },
};

export const marquee = [
  "Certificação MTVDE",
  "Formação Inicial",
  "Renovação",
];

export const program = {
  label: "O programa",
  title: "A formação necessária para iniciares a tua atividade",
  description:
    "Para exercer a atividade de motorista TVDE é necessário frequentar, com aproveitamento, a formação adequada e obter a respetiva certificação profissional.",
  cards: [
    {
      number: "01",
      title: "Formação Inicial TVDE",
      meta: "50 horas · B-learning",
      price: "200€",
      description:
        "Indicada para quem pretende começar a exercer a atividade de motorista TVDE. Durante a formação vais desenvolver conhecimentos e competências em:",
      image:
        "https://customer-assets-v7afamib.emergentagent.net/job_tvde-academy/artifacts/7d4p1jy8_pexels-freestocks-34239.webp",
      imageAlt: "Aplicação de plataforma digital de mobilidade no telemóvel",
      bullets: [
        "Comunicação e relacionamento com os passageiros",
        "Normas legais e regulamentação da atividade",
        "Condução segura, defensiva e confortável",
        "Utilização de plataformas digitais",
        "Situações de emergência e primeiros socorros",
        "Componente prática de condução",
      ],
      requirements: [
        "Cartão de Cidadão / Título de Residência",
        "Carta de condução Portuguesa (necessário ter carta há mais de 3 anos)",
        "Morada completa",
        "Contacto telefónico e email",
        "Matrícula do carro a utilizar na componente prática",
      ],
      imageSide: "left",
    },
    {
      number: "02",
      title: "Renovação TVDE",
      meta: "8 horas · Presencial ou e-learning",
      price: "90€",
      description:
        "Destinada a motoristas TVDE que pretendem renovar a sua certificação e continuam a cumprir os requisitos de acesso à atividade.",
      image:
        "https://customer-assets-v7afamib.emergentagent.net/job_tvde-academy/artifacts/u624k6xm_pexels-airamdphoto-15487492.webp",
      imageAlt: "Interior de viatura TVDE com taxímetro em atividade",
      bullets: [],
      requirements: [
        "Cartão de Cidadão / Título de Residência",
        "Carta de condução Portuguesa",
        "Morada completa",
        "Contacto telefónico e email",
        "Cartão válido TVDE",
      ],
      imageSide: "right",
    },
  ],
};

export const contact = {
  label: "Contacto",
  title: "Quero receber informações",
  description:
    "Preenche o formulário e a nossa equipa entrará em contacto contigo para esclarecer as tuas dúvidas e informar-te sobre as próximas turmas.",
  note: "Preencher o formulário não implica qualquer compromisso de inscrição.",
  options: [
    { value: "inicial", label: "Formação Inicial" },
    { value: "renovacao", label: "Renovação" },
    { value: "nao-sei", label: "Não tenho a certeza" },
  ],
  consent:
    "Concordo com a utilização dos meus dados para ser contactado com informações sobre o curso, de acordo com a Política de Privacidade.",
  submit: "Quero ser contactado",
};

export const footer = {
  headingA: "Grupo IFT — Formação e acompanhamento para o teu ",
  headingAccent: "futuro profissional",
  emailLabel: "E-mail",
  locationLabel: "Localização",
  copyright: "© 2026 Grupo IFT. Todos os direitos reservados.",
  reserved: "Visitar o website do Grupo IFT",
  reservedUrl: "https://grupoift.pt/",
};
